import { useEffect, useState } from 'react';
import { Crown, ArrowRight, Check } from 'lucide-react';
import { api, formatError } from '../lib/api';
import { toast } from 'sonner';

const PERKS = [
  'Top of search in your suburbs',
  'Unlimited Risk & Trust checks before you quote',
  'Property Passport job history + warranty vault',
  'Verified Pro badge on your public profile',
];

export const ProUpgradeCard = () => {
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.tradieSubscription().then((r) => setSub(r.data)).catch(() => {});
  }, []);

  const checkout = async (lookupKey) => {
    setBusy(lookupKey);
    try {
      const { data } = await api.createCheckout(lookupKey);
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatError(err));
      setBusy(null);
    }
  };

  if (sub?.status === 'active') {
    return (
      <div className="mt-8 flex items-center gap-3 border border-[#1A362D] bg-[#1A362D] px-6 py-4 text-white" data-testid="pro-active-banner">
        <Crown size={18} className="text-[#E9C46A]" />
        <span className="text-sm font-semibold uppercase tracking-[0.15em]">Tradie Pro active</span>
      </div>
    );
  }

  return (
    <div className="mt-8 border border-[#1C1B1A] bg-white" data-testid="pro-upgrade-card">
      <div className="grid gap-8 p-6 md:grid-cols-[1.2fr_1fr] md:p-8">
        <div>
          <div className="inline-flex items-center gap-2 border border-[#E9C46A] bg-[#E9C46A]/[0.12] px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#B08911]">
            <Crown size={12} /> Tradie Pro
          </div>
          <h2 className="mt-4 font-heading text-3xl font-bold leading-tight tracking-tight text-[#1C1B1A]">
            Win the jobs you're already <span className="italic text-[#1A362D]">quoting on</span>.
          </h2>
          <ul className="mt-5 space-y-2 text-sm text-[#5C5B5A]">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-2">
                <Check size={15} className="mt-0.5 shrink-0 text-[#1A362D]" /> <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col justify-center gap-3 border-t border-[#E5E4E0] pt-6 md:border-l md:border-t-0 md:pl-8 md:pt-0">
          <button onClick={() => checkout('tradie_pro_monthly')} disabled={!!busy} data-testid="pro-monthly-btn"
            className="flex w-full items-center justify-between gap-2 border border-[#1C1B1A] bg-[#1C1B1A] px-5 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#1A362D] disabled:opacity-50">
            <span>{busy === 'tradie_pro_monthly' ? 'Opening checkout…' : '$49 / month'}</span> <ArrowRight size={16} />
          </button>
          <button onClick={() => checkout('tradie_pro_yearly')} disabled={!!busy} data-testid="pro-yearly-btn"
            className="flex w-full items-center justify-between gap-2 border border-[#1C1B1A] px-5 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-[#1C1B1A] transition-colors hover:bg-[#F3F2EE] disabled:opacity-50">
            <span>{busy === 'tradie_pro_yearly' ? 'Opening checkout…' : '$470 / year'}</span> <ArrowRight size={16} />
          </button>
          <p className="text-xs text-[#8A8988]">Cancel any time. GST invoice emailed automatically.</p>
        </div>
      </div>
    </div>
  );
};

export default ProUpgradeCard;
